import ShareButton from '@components/shared/buttons/ShareButton/ShareButton';
import React, { useContext } from 'react';
import ShowAt from '@components/shared/conditional/ShowAt';
import VendorVariantContext from '@context/VendorVariant/vendor-variant-context';
import RatingFill from '@components/shared/RatingFill/RatingFill';
import classNames from 'classnames';
import { useTheme } from '@components/theme';
import { isInStock, isBackordered, IVendorVariantInternal } from '@models/VendorVariant/i-vendor-variant';
import RegularSalePriceDisplay
  from '@components/shared/prices/RegularSalePriceDisplay/RegularSalePriceDisplay';
import styles from './ProductInfo.module.scss';
import VendorPromotion from '../VendorPromotion/VendorPromotion';

interface IProductInfoProps {
  onShare: () => void;
  onClickReviews: () => void;
  className?: string;
}

const ProductInfo = ({
  onShare,
  onClickReviews,
  className = ''
}: IProductInfoProps) => {
  const vendorVariant = useContext(VendorVariantContext);
  const theme = useTheme();
  const isOutOfStock = !isInStock(vendorVariant.availability);
  const isBackOrdered = isBackordered(vendorVariant.availability);

  return (
    <div className={classNames(className, styles.ProductInfo)}>
      <div className={styles.VendorContainer}>
        <span
          className={classNames(styles.Vendor)}
          data-test="vendor"
        >
          {vendorVariant.vendor.name}
        </span>
      </div>

      <div className={styles.TitleWrapper}>
        <div
          className={classNames(styles.Title, theme.styles.Title1)}
          data-test="product-title"
        >
          {vendorVariant.title}
        </div>

        <ShowAt breakpoint="desktop">
          <ShareButton
            className={styles.Share}
            onClick={ onShare }
          />
        </ShowAt>
      </div>

      {isOutOfStock && !isBackOrdered && <span className={styles.OutOfStock}>Out of stock</span>}

      {!isOutOfStock && isBackOrdered && <span className={styles.OutOfStock}>Back ordered</span>}

      <div className={styles.PriceStarsWrapper}>
        {!isOutOfStock && (
          <RegularSalePriceDisplay product={vendorVariant} className={styles.Price} />
        )}

        {!!vendorVariant.reviewStats?.count &&
        !!vendorVariant.reviews?.items.length && (
          <button
            type="button"
            className={styles.ReviewWrapper}
            onClick={onClickReviews}
          >
            <RatingFill
              compact
              id="rating-summary"
              rating={vendorVariant.reviewStats?.average || 5}
              theme="havenly"
            />
            <span className={styles.ReviewCount}>&#40;{vendorVariant.reviewStats.count}&#41;</span>
          </button>
        )
      }
      </div>

      <VendorPromotion
        className={styles.PromotionText}
        vendorVariant={vendorVariant as IVendorVariantInternal}
      />
    </div>
  );
};
export default ProductInfo;
